import * as React from 'react';

import { Query } from 'react-apollo';
// @ts-ignore
import { connect } from 'react-redux';

// @ts-ignore
import UnreadActions from 'actions/UnreadActions';
import ErrorReporter from 'app/components/ErrorReporter';
import OverlayLoading from 'components/OverlayLoading';
// @ts-ignore
import ClassNavigationPromotionContainer from 'groups/containers/ClassNavigationPromotionContainer';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';
import CurrentUser from 'auth/CurrentUser';

import NavigationListLoadTimer from './NavigationListLoadTimer';
import NavigationListCoachingSection from './NavigationListCoachingSection';
import NavigationListSection from './NavigationListSection';
import NavigationListSectionItems from './NavigationListSectionItems';

import {
  NavigationList as NavigationListQuery,
  NavigationList_me_navigationSections,
  NavigationList_me_navigationSections_items_CoachingStream,
} from 'queries/__generated__/NavigationList';

import NavigationQuery from 'queries/navigationList.gql';

import './styles/NavigationList.scss';

export const TOUCH_KEY = 'NAVIGATION_LIST';

type Props = {
  onRefetch?: () => void;
};

type ReduxStateProps = {
  touch: string;
};

type State = {
  lastSeenTouch?: string;
};

class NavigationList extends React.Component<Props & ReduxStateProps, State> {
  state: State = {
    lastSeenTouch: undefined,
  };

  componentDidMount() {
    if (UnreadStore.getUnreads().isEmpty()) {
      UnreadActions.loadUnreads();
    }
  }

  renderSection = (section: NavigationList_me_navigationSections) => {
    const sectionKey = section.key;
    if (sectionKey === 'coachingCoachStreams' || sectionKey === 'coachingParticipantStreams') {
      const items = section.items?.filter(
        (i): i is NavigationList_me_navigationSections_items_CoachingStream =>
          i.__typename === 'CoachingStream'
      );
      return (
        <NavigationListCoachingSection
          sectionKey={sectionKey}
          key={sectionKey}
          items={items ?? []}
        />
      );
    }

    const isDistrictSection = sectionKey === 'districts';
    if (section.items?.length) {
      return (
        <NavigationListSection key={sectionKey} title={section.label || undefined}>
          <NavigationListSectionItems
            items={section.items || []}
            isDistrictSection={isDistrictSection}
          />
        </NavigationListSection>
      );
    }

    return null;
  };

  render() {
    const currentUser = CurrentUser.getUser();
    return (
      <Query<NavigationListQuery> query={NavigationQuery} notifyOnNetworkStatusChange>
        {({ loading, error, data, refetch }) => {
          if (this.state.lastSeenTouch !== this.props.touch) {
            refetch();

            if (this.props.onRefetch) {
              this.props.onRefetch();
            }

            this.setState({
              lastSeenTouch: this.props.touch,
            });
          }

          if (error) {
            return <ErrorReporter error="NavigationList - failed to load navigation sections" />;
          }

          const sections = data && data.me && data.me.navigationSections;
          const navList = sections ? (
            <nav className="NavigationList-content">
              <NavigationListLoadTimer />
              <ClassNavigationPromotionContainer />
              {sections.map(this.renderSection)}
            </nav>
          ) : null;

          return (
            <div className="NavigationList" style={{ position: 'relative' }}>
              {loading && <OverlayLoading />}
              {navList}
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state: any): ReduxStateProps {
  return {
    touch: state.touch.get(TOUCH_KEY) as string,
  };
}

export { NavigationList };
export default connect<ReduxStateProps, undefined, Props>(mapStateToProps)(NavigationList);
